module.exports = __webpack_public_path__ + "img/m-footer-bg.7e366f5d.png";